/**
 * 配列を指定されたサイズごとに分割
 * @param arr 対象の配列
 * @param size 分割サイズ（１要素あたりの数）
 * @returns 分割された配列
 */
export const chunkArray = <T>(arr: T[], size: number): T[][] => {
  const chunks: T[][] = []
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size))
  }
  return chunks
}
